import type { LocaleObject as I18nLocaleObject } from '@nuxtjs/i18n'
import domains from './domains'

export enum Locale {
  De = 'de',
  At = 'at',
  Ch = 'ch',
  FrCh = 'fr-ch',
  FrBe = 'fr-be',
  Fr = 'fr',
  Be = 'be',
  Nl = 'nl',
  Fi = 'fi',
}

export interface LocaleObject extends I18nLocaleObject<Locale> {
  code: Locale
  iso: string
  domain: string
  file: string
}

const locales: LocaleObject[] = [
  {
    code: Locale.At,
    iso: 'de-AT',
    domain: domains['de-AT'],
    file: 'de-AT.json',
  },
  {
    code: Locale.Be,
    iso: 'nl-BE',
    domain: domains['nl-BE'],
    file: 'nl-BE.json',
  },
  {
    code: Locale.FrBe,
    iso: 'fr-BE',
    domain: domains['fr-BE'],
    file: 'fr-BE.json',
  },
  {
    code: Locale.Ch,
    iso: 'de-CH',
    domain: domains['de-CH'],
    file: 'de-CH.json',
  },
  {
    code: Locale.FrCh,
    iso: 'fr-CH',
    domain: domains['fr-CH'],
    file: 'fr-CH.json',
  },
  {
    code: Locale.De,
    iso: 'de-DE',
    domain: domains['de-DE'],
    file: 'de-DE.json',
  },
  {
    code: Locale.Fi,
    iso: 'fi-FI',
    domain: domains['fi-FI'],
    file: 'fi-FI.json',
  },
  {
    code: Locale.Fr,
    iso: 'fr-FR',
    domain: domains['fr-FR'],
    file: 'fr-FR.json',
  },
  {
    code: Locale.Nl,
    iso: 'nl-NL',
    domain: domains['nl-NL'],
    file: 'nl-NL.json',
  },
]

export const getLocaleIsoCode = (code: Locale): string => {
  return locales.find((locale) => locale.code === code)!.iso
}

export default locales
